module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 8.063 11.15",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#arrow",
      toString: function () {
        return this.url;
      }
    }